import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { from, Observable } from 'rxjs';
import { ShareService } from '@nttp/common-service/share-service';
import { LeadType } from '@nttp/enum/lead-type.enum';
import { UserRoleEnum } from '@nttp/enum/user-role.enum';

@Injectable({
    providedIn: 'root'
})
export class UserManagementGuard implements CanActivate {
    constructor(
        private shareService: ShareService,
        private router: Router,
        private toastr: ToastrService
    ) { }
    canActivate() {
        const getRole = new Promise(resolve => {
            this.shareService.accountType$.subscribe(data => {
                const canAccess = data.leadType !== LeadType.Private && data.clientRole === UserRoleEnum.Administrator;
                if (!canAccess) {
                    this.router.navigate(['client/dashboard']);
                    this.toastr.error(
                        'You are not enabled for access to this screen. Let the Tech Guys know if you believe you have encountered this message in error',
                        '',
                        {
                            timeOut: 5000
                        }
                    );
                    resolve(false);
                }
                resolve(true);
            });
        });
        return from(getRole) as Observable<boolean>;
    }
}
